AbsenceRequestsDashboard;

import AbsenceRequestsDashboard from "components/Dashboard/AbsenceRequests";

const AbsenceRequestsDashboardPage = () => {
  return <AbsenceRequestsDashboard />;
};

export default AbsenceRequestsDashboardPage;
